/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Nav_VideosInputs */

const en_settings_nav_videos = /** @type {(inputs: Settings_Nav_VideosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My videos`)
};

/**
* | output |
* | --- |
* | "My videos" |
*
* @param {Settings_Nav_VideosInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_nav_videos = /** @type {((inputs?: Settings_Nav_VideosInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Nav_VideosInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_nav_videos(inputs)
});
export { settings_nav_videos as "settings.nav.videos" }